import type {
  MutationFunction,
  MutationKey,
  UseMutationOptions,
  UseMutationResult,
} from 'react-query';
import {useMutation as useReactQueryMutation} from 'react-query';
import {useProject} from '@sail/observability';

export const useMutation = <
  TData = unknown,
  TError = unknown,
  TVariables = void,
  TContext = unknown,
>(
  mutationKey: MutationKey,
  mutationFn?: MutationFunction<TData, TVariables>,
  options?: Omit<
    UseMutationOptions<TData, TError, TVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
): UseMutationResult<TData, TError, TVariables, TContext> => {
  const {meta} = options || {};
  const owner = useProject();
  return useReactQueryMutation(mutationKey, mutationFn, {
    ...options,
    meta: {
      ...meta,
      owner,
    },
  });
};
